import { state } from "@angular/animations";
import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { Action, createAction, createReducer, on, Store } from "@ngrx/store";
import { ShellActions } from "@opm/ng-core";
import { ProfileService } from "core/services/profile.service";
import { catchError, mergeMap } from "rxjs/operators";
import { State } from ".";
import { Affiliation } from "../../shared/models/affiliation";
import { Agency } from "../../shared/models/agency";
import { BUSCode } from "../../shared/models/busCode";
import { CPDFCode } from "../../shared/models/cpdfCode";
import { Union } from "../../shared/models/union";

export namespace Lookups {
	export const updateAgencies = createAction('[Lookups] - Update Agencies', (items: string[]) => ({ items }));
  export const loadAgencies = createAction('[Lookups] - Load Agencies');
  export const updateAgencyObjects = createAction('[Lookups] - Update Agency Objects', (items: Agency[]) => ({ items }));
  export const loadAgencyObjects = createAction('[Lookups] - Load Agency Objects');

	export const updateUnions = createAction('[Lookups] - Update Unions', (items: string[]) => ({ items }));
  export const loadUnions = createAction('[Lookups] - Load Unions');
  export const updateUnionObjects = createAction('[Lookups] - Update Union Objects', (items: Union[]) => ({ items }));
  export const loadUnionObjects = createAction('[Lookups] - Load Union Objects');

	export const updateOlmrNumbers = createAction('[Lookups] - Update OlmrNumbers', (items: string[]) => ({ items }));
	export const loadOlmrNumbers = createAction('[Lookups] - Load OlmrNumbers');

	export const updateBusCodes = createAction('[Lookups] - Update BusCodes', (items: string[]) => ({ items }));
  export const loadBusCodes = createAction('[Lookups] - Load BusCodes');
  export const updateBusCodeObjects = createAction('[Lookups] - Update BUS Code Objects', (items: BUSCode[]) => ({ items }));
  export const loadBusCodeObjects = createAction('[Lookups] - Load BUS Code Objects');

  export const updateCpdfCodeObjects = createAction('[Lookups] - Update CPDF Code Objects', (items: CPDFCode[]) => ({ items }));
  export const loadCpdfCodeObjects = createAction('[Lookups] - Load CPDF Code Objects');

  export const updateAffiliationObjects = createAction('[Lookups] - Update Affiliation Objects', (items: Affiliation[]) => ({ items }));
  export const loadAffiliationObjects = createAction('[Lookups] - Load Affiliation Objects');

	export interface LookupState {
    agencies: string[];
    agencyObjects: Agency[];
    unions: string[];
    unionObjects: Union[]
    olmrNumbers: string[];
    cpdfCodeObjects: CPDFCode[];
    busCodes: string[];
    busCodeObjects: BUSCode[];
    affiliationObjects: Affiliation[];
	}

	const initialLookupState: LookupState = {
    agencies: [],
    agencyObjects: [],
    unions: [],
    unionObjects: [],
		olmrNumbers: [],
    cpdfCodeObjects: [],
    busCodes: [],
    busCodeObjects: [],
    affiliationObjects: []
	}

	const lookupReducer = createReducer(
		initialLookupState,
    on(updateAgencies, (state, { items }) => { return { ...state, agencies: items } }),
    on(updateAgencyObjects, (state, { items }) => { return { ...state, agencyObjects: items } }),
    on(updateUnions, (state, { items }) => { return { ...state, unions: items } }),
    on(updateUnionObjects, (state, { items }) => { return { ...state, unionObjects: items } }),
    on(updateOlmrNumbers, (state, { items }) => { return { ...state, olmrNumbers: items } }),
    on(updateCpdfCodeObjects, (state, { items }) => { return { ...state, cpdfCodeObjects: items } }),
    on(updateBusCodes, (state, { items }) => { return { ...state, busCodes: items } }),
    on(updateBusCodeObjects, (state, { items }) => { return { ...state, busCodeObjects: items } }),
    on(updateAffiliationObjects, (state, { items }) => { return { ...state, affiliationObjects: items } })
	)

	export function reducer(state: LookupState = initialLookupState, action: Action): LookupState {
		return lookupReducer(state, action);
	}
}
